import React, {
    Component
} from 'react';
import { withRouter} from 'react-router-dom';

/* eslint-disable */
class StyleSwitcher extends Component {

    render() {
        return (
          <div id="style_switcher">
              <div id="style_switcher_toggle"><i className="material-icons">&#xE8B8;</i></div>
              <div className="uk-margin-medium-bottom">
                  <h4 className="heading_c uk-margin-bottom">Colors</h4>
                  <ul className="switcher_app_themes" id="theme_switcher">
                      <li className="app_style_default active_theme" data-app-theme="">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_a" data-app-theme="app_theme_a">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_b" data-app-theme="app_theme_b">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_c" data-app-theme="app_theme_c">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_d" data-app-theme="app_theme_d">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_e" data-app-theme="app_theme_e">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_f" data-app-theme="app_theme_f">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_g" data-app-theme="app_theme_g">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_h" data-app-theme="app_theme_h">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                      <li className="switcher_theme_i" data-app-theme="app_theme_i">
                          <span className="app_color_main"></span>
                          <span className="app_color_accent"></span>
                      </li>
                  </ul>
              </div>
              <div className="uk-visible-large uk-margin-medium-bottom">
                  <h4 className="heading_c">Sidebar</h4>
                  <p>
                      <input type="checkbox" name="style_sidebar_mini" id="style_sidebar_mini" data-md-icheck />
                      <label htmlFor="style_sidebar_mini" className="inline-label">Mini Sidebar</label>
                  </p>
              </div>
          </div>

        );
    }
}

export default withRouter(StyleSwitcher);



// WEBPACK FOOTER //
// ./src/components/Layout/StyleSwitcher.js